import { useState, useEffect } from "react";
import { useGetDispositionLevelOneQuery } from "src/services/DispositionLevelOneServices";

const useDispositionLevelOne = () => {
    const [DispositionLevelOne, setDispositionLevelOne] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetDispositionLevelOneQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setDispositionLevelOne(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { DispositionLevelOne, isDataLoading };
};

export default useDispositionLevelOne;
